import { useInjection } from 'inversify-react';
import { useState } from 'react';

import {
  TYPES as PROJECT_SERVICE_TYPES,
  ProjectsFacade,
  useProjectsStore,
} from '@desygner/ui-features-projects';

export const useCreateProject = () => {
  const [status, setStatus] = useState<'pending' | 'success' | 'error' | 'idle'>('idle');
  const projectService = useInjection<ProjectsFacade>(PROJECT_SERVICE_TYPES.ProjectsFacade);
  const { project } = useProjectsStore();

  function createProjectAsync() {
    const projectId = project.currentProject?.id;

    if (!projectId) return;

    setStatus('pending');

    return projectService
      .createProject({
        template: projectId,
      })
      .then((newProject) => {
        setStatus('success');

        return newProject;
      })
      .catch((error) => {
        setStatus('error');

        throw error;
      })
      .finally(() => {
        setStatus('idle');
      });
  }

  return {
    status,
    createProjectAsync,
  };
};
